import EastRoundedIcon from "@mui/icons-material/EastRounded";
import { Box, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../api/hooks/useColors";
import PercentageLabel from "../../frameworks/components/PercentageLabel";
import FunctionDrawer from "./FunctionDrawer";
import NISTCategory from "./NISTCategory";
const getFunctionShortName = (func) => func.split(" ")[0];

const NISTFunction = ({ nistFunction }) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const colors = useColors();
  // Map function names to colors for the left border
  const functionColors = {
    Protect: colors.nist_protect_stroke,
    Detect: colors.nist_detect_stroke,
    Respond: colors.nist_respond_stroke,
    Recover: colors.nist_recover_stroke,
    Govern: colors.nist_govern_stroke,
    Identify: colors.nist_identify_stroke,
  };

  if (!nistFunction) return null;

  // Calculate average score for the function
  const avgScore = Math.round(
    nistFunction.categories
      .filter((cat) => cat.score >= 0)
      .reduce((sum, cat) => sum + cat.score, 0) /
      nistFunction.categories.filter((cat) => cat.score >= 0).length
  );

  return (
    <Box
      sx={{
        borderRadius: 3,
        p: "12px 16px",
        borderLeft: `6px solid ${
          functionColors[nistFunction.function] || colors.grey_50
        }`,
        background: colors.grey_50,
        boxShadow: `2px 2px 0px 1px ${colors.grey_12percent},  0px -1px 0px 0px ${colors.grey_12percent}`,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        transition: "all 0.2s ease-in-out",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            gap: 2,
          }}
        >
          <Typography variant="subtitle2">
            {getFunctionShortName(nistFunction.function)}
          </Typography>
          <PercentageLabel
            applicable={avgScore >= 0}
            percentage={avgScore >= 0 ? avgScore : 0}
            sx={{ borderRadius: "10px", height: "20px" }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 1,
            cursor: "pointer",
          }}
        >
          <Typography
            variant="caption"
            onClick={() => {
              setOpenDrawer(true);
            }}
          >
            View Function Details
          </Typography>
          <EastRoundedIcon sx={{ fontSize: "16px" }} />
        </Box>
      </Box>
      <Box display="flex" flexDirection="row" flexWrap="wrap" gap="12px">
        {nistFunction.categories.map((category) => (
          <Box key={category.id}>
            <NISTCategory nistFunction={nistFunction} category={category} />
          </Box>
        ))}
      </Box>
      <FunctionDrawer
        open={openDrawer}
        onClose={(e) => {
          e.stopPropagation();
          setOpenDrawer(false);
        }}
        nistFunction={nistFunction}
        averageScore={avgScore}
      />
    </Box>
  );
};

export default NISTFunction;
